<script>
import options from "./ProductInfoTablist.options";
export default options;
</script>

<template>
    <article class="nti-product-info-tablist">
        <nav class="nti-product-info-tablist__tab-container tabs-filter">
            <template v-for="data in tablistData" :key="data.id">
                <button 
                    class="nti-product-info-tablist__tablink__wrapper nti-button nti-button--no-styling" 
                    v-on:click="activateTab(data.id)" 
                    aria-controls="description" 
                    role="tab">
                    <a class="nav-link nav-link--webshop nti-product-info-tablist__tablink" v-bind:class="{ 'active' : selectedTab === data.id }">{{data.tabHeader}}</a>
                </button>
            </template>
        </nav>
        <section class="nti-product-info-tablist__tabcontent" id="description" role="tabpanel">
            <template v-for="(data, indexContent) in tabContentData" :key="'A'+ indexContent">
                <p class="nti-product-info-tablist__tabcontent__text" v-html="data.text"></p>
            </template>
            <template v-for="(link, indexLink) in tabLinkData" :key="'B'+ indexLink">
                <a :href="link.url">{{link.text}}</a>
            </template>
            <template v-if="tabVideoData">
                <div class="block-embed nti-product-info-tablist__video">
                    <div class="video media parallax" data-rellax-speed="-0.25" data-rellax-percentage="-0.25" style="transform: translate3d(0px, 55px, 0px) translate3d(0px, 15px, 0px);">
                        <iframe :src="tabVideoData" frameborder="0" allowfullscreen=""></iframe>
                    </div>
                    <div class="background-box parallax" data-rellax-speed="1" data-rellax-percentage="0.5" style="transform: translate3d(0px, -148px, 0px) translate3d(0px, 0px, 0px);"></div>
                </div>
            </template>

            <template v-if="tabNativeVideoData">
                <div class="block-embed nti-product-info-tablist__video">
                    <div class="video media parallax" data-rellax-speed="-0.25" data-rellax-percentage="-0.25" style="transform: translate3d(0px, 55px, 0px) translate3d(0px, 15px, 0px);">
                        <video id='native-video-player' preload='metadata' :autoplay="tabNativeVideoData.autoplayVideo" :poster="tabNativeVideoData.posterLink" @play="tabNativeVideoData.onVideoPlay" @pause="tabNativeVideoData.onVideoPause" @click="tabNativeVideoData.onVideoClick">
                            <source :src="tabNativeVideoData.videoLink" type="video/mp4">
                        </video>
                    </div>
                    <div class="background-box parallax" data-rellax-speed="1" data-rellax-percentage="0.5" style="transform: translate3d(0px, -148px, 0px) translate3d(0px, 0px, 0px);"></div>
                </div>
            </template>
        </section>
    </article>
</template>